window.onload = function () {
    const hideAll = document.getElementById('hideAll')
    if (hideAll) hideAll.style.display = 'none'
}

const form = document.querySelector('form[data-contact-form]')
if (form) {
    const thankYouEl = document.getElementById('thank-you-message')
    const errorEl = document.getElementById('form-error-message')
    const submitBtn = document.getElementById('form-submit')

    form.addEventListener('submit', async (e) => {
        e.preventDefault()
        if (errorEl) {
            errorEl.classList.remove('show')
            errorEl.textContent = ''
        }
        if (thankYouEl) thankYouEl.classList.remove('show')

        const name = (form.querySelector('[name="name"]') || {}).value
        const email = (form.querySelector('[name="email"]') || {}).value
        const message = (form.querySelector('[name="message"]') || {}).value
        if (!name || !email || !message) {
            if (errorEl) {
                errorEl.textContent = 'Please fill in name, email, and message.'
                errorEl.classList.add('show')
            }
            return
        }

        const token = (form.querySelector('[name="cf-turnstile-response"]') || {}).value
        if (!token || !token.trim()) {
            if (errorEl) {
                errorEl.textContent = 'Please complete the verification challenge.'
                errorEl.classList.add('show')
            }
            return
        }

        if (submitBtn) {
            submitBtn.classList.add('loading')
            submitBtn.disabled = true
            submitBtn.innerHTML = '<i class="fa fa-spinner fa-spin"></i>&nbsp;Sending...'
        }

        const formData = new URLSearchParams(new FormData(form))

        try {
            const res = await fetch('/send-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
            })

            if (res.redirected) {
                window.location.href = res.url
                return
            }

            if (res.ok) {
                window.location.href = '/thank-you.html'
                return
            }

            const text = await res.text()
            if (errorEl) {
                errorEl.textContent = text || 'Something went wrong. Please try again or email us at admin@smazlabs.com.'
                errorEl.classList.add('show')
            }
        } catch (err) {
            if (errorEl) {
                errorEl.textContent = 'Something went wrong. Please try again or email us at admin@smazlabs.com.'
                errorEl.classList.add('show')
            }
        } finally {
            if (submitBtn) {
                submitBtn.classList.remove('loading')
                submitBtn.innerHTML = '<i class="fa fa-paper-plane"></i>&nbsp;Send message'
                submitBtn.disabled = true
            }
        }
    })
}
